import {createSelector} from 'reselect';

import {EMPTY_ARRAY} from '~/shared/consts/commonConsts';
import {is401Error} from '~/shared/services/apiErrorService';
import {IMoneycardsRes} from '~/shared/services/bffService/api/interfaces/responses';

import {AppState} from '../../configStore';

import {MoneyCardsState} from './moneyCardsReducer';

export const selectMoneyCardsState = (state: AppState): MoneyCardsState => state.moneyCards;

export const selectMoneyCards = createSelector(
  selectMoneyCardsState,
  ({data}) => data || (EMPTY_ARRAY as IMoneycardsRes),
);

export const selectMoneyCardsLoading = createSelector(
  selectMoneyCardsState,
  ({loading}) => loading,
);

export const selectMoneyCardsLoaded = createSelector(
  selectMoneyCardsState,
  ({loaded}) => loaded,
);

// A 401 is left out, as `useMoneyCards` refreshes the token and retries the request instead of
// letting the consumers render a failure that is about to resolve itself
export const selectMoneyCardsError = createSelector(
  selectMoneyCardsState,
  ({error}) => (is401Error(error) ? undefined : error),
);

export const selectTenbisCreditBalance = createSelector(
  selectMoneyCards,
  moneyCards => moneyCards.find(({isTenbisCredit}) => isTenbisCredit)?.balance || 0,
);

export const selectHasWalletCard = createSelector(
  selectMoneyCards,
  moneyCards => moneyCards.some(({isWalletCard}) => isWalletCard),
);
